// extracted by mini-css-extract-plugin
export default {"root":"Search_root__n8+IT","input":"Search_input__3-h7Y","icon":"Search_icon__LZjR5","clearIcon":"Search_clearIcon__0ffCF"};